/**
 * The @api registry — every backend call goes through here, merged from one
 * file per surface so parallel work never edits the same file:
 *   api/shared.js      auth + generic KORM door (`crud`)
 *   api/storefront.js  customer storefront / PWA
 *   api/merchant.js    merchant back office (/admin)
 *   api/platform.js    Super Admin console (platform host)
 *   api/service.js     service / repair partner portal (/service)
 *   api/marketplace.js in-store vendors: vendor portal (/vendor) + admin Vendors pages (B17)
 *
 * An entry with no backend yet returns fixture('<key>', params) — see lib/fixtures.js.
 * Keys must be unique across files (checked below).
 */
import shared from './shared';
import storefront from './storefront';
import merchant from './merchant';
import platform from './platform';
import service from './service';
import marketplace from './marketplace';

const parts = { shared, storefront, merchant, platform, service, marketplace };
const merged = {};
for (const [surface, map] of Object.entries(parts)) {
  for (const [key, fn] of Object.entries(map)) {
    if (merged[key]) throw new Error(`@api key "${key}" defined twice (in ${surface})`);
    merged[key] = fn;
  }
}

export default merged;
